import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { CustomPrice } from '../customPrice'
import classes from './index.module.scss'

export const ReportPrice = ({ data, isOneLine }) => {
  const renderPrice = () => {
    return (
      <>
        <div className="fw600">
          <Translate value="domesticSearchPreview.PRICE" />
        </div>

        <div className={isOneLine ? 'dFlex gap1 justifyContentEnd' : ''}>
          {data.totalPrice !== data.price && (
            <CustomPrice
              value={data.totalPrice}
              style={{
                color: '#9C9C9C',
                textDecorationLine: 'line-through',
                fontSize: 14,
              }}
              isShowIcon={false}
            />
          )}

          <CustomPrice
            value={data.price}
            style={{
              color: '#0553A5',
              fontSize: 14,
              fontWeight: 600,
            }}
          />
        </div>
      </>
    )
  }

  return <div className={classes.reportPriceContainer}>{renderPrice()}</div>
}

ReportPrice.propTypes = {
  data: PropTypes.shape({
    price: PropTypes.number,
    totalPrice: PropTypes.number,
  }).isRequired,
  isOneLine: PropTypes.bool,
}

ReportPrice.defaultProps = {
  data: {},
  isOneLine: false,
}
